// fn_profile_picker

var fn_search = function () {

    $('#searchsite__wrapper').on('shown.bs.collapse', function () {
        // do something…
        $("#searchsite__wrapper .btn-close").focus();
      })

}